var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"verde-sys-icons"}},[_c(_vm.name,{tag:"component",attrs:{"color":_vm.color,"color-primary":_vm.colorPrimary,"color-secondary":_vm.colorSecondary,"width":_vm.width,"height":_vm.height,"opacity":_vm.opacity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }